/* PRODUIT PAR scripts/build-theme.mjs — ne pas modifier à la main. */

/* LE MÊME COMMUTATEUR QUE LA FEUILLE, et il doit l'être.

   Première version : seul le CSS était gardé par `mt-kiosk`, le module
   démarrait toujours. Résultat mesuré sur le thème d'essai — sans
   `?editeur`, `window.__MT_TEXTE__` était quand même une fonction. La
   couronne se construisait, et le double appui partait dans le popup.
   La page « de référence » n'en était plus une, et la comparaison que
   tout ce montage sert à rendre possible ne valait rien.

   Une couche à moitié éteinte est pire qu'une couche allumée : on croit
   comparer deux états alors qu'on en compare un seul. */
if (document.documentElement.classList.contains('mt-kiosk')) {
  /* SI LA COUCHE TOMBE, LA TOMETTE PHOTO LE SAIT.

     Le Promise.all qui suit est attendu : s'il rejette, plus rien de ce
     bloc ne s'exécute, et le module photo ne part jamais. Sans cette
     garde, window.__MTPX_ECHEC__ resterait vide : une création photo
     reprise sur la pièce entendrait sans fin « l'atelier photo se charge
     encore », et le carrousel attendrait son échéance de 15 s pour rien.
     On réécoute donc les mêmes modules — le navigateur ne charge chacun
     qu'une fois, ce second appel ne coûte rien — et, s'ils échouent, on
     pose l'échec photo comme le ferait le module lui-même. La liste est
     comparée à celle du Promise.all à la construction. Pas d'accents
     graves ici, ce commentaire vit dans le gabarit du démarrage. */
  const MTPX_COUCHE = [
    '/theme/stats.js', '/kiosk/touch.js', '/kiosk/gravure-guard.js', '/kiosk/police-picker.js',
    '/kiosk/couronne.js', '/kiosk/ajouter.js', '/theme/valider-web.js', '/kiosk/logo-picker.js',
    '/theme/rotation-coins.js', '/theme/barre-haut.js', '/theme/lieu.js', '/theme/prix-format.js',
    '/theme/sceau-web.js', '/theme/menu-mobile.js', '/theme/tuto-mobile.js', '/theme/tuto-bureau.js',
    '/theme/logo-perso.js', '/theme/couronne-actions.js', '/theme/mes-logos.js', '/theme/attente.js',
    '/theme/geste-nu.js', '/theme/catalogue.js', '/theme/cadrage.js', '/theme/arc-creux.js',
    '/theme/polices.js', '/theme/ecrire.js', '/theme/chercher-logo.js', '/theme/lien-court.js',
    '/theme/valider-client.js',
  ];
  Promise.all(MTPX_COUCHE.map((u) => import(u))).catch((e) => {
    window.__MTPX_ECHEC__ = true;
    try { document.dispatchEvent(new CustomEvent('mtp:echec', { detail: { message: 'couche : ' + String((e && e.message) || e) } })); } catch (_) { /* rien */ }
    /* La carte gravée a le même besoin, pour la même raison : sans couche,
       son module ne part jamais, et le carrousel attendrait pour rien. */
    window.__MTCX_ECHEC__ = true;
    try { document.dispatchEvent(new CustomEvent('mtcx:echec', { detail: { message: 'couche : ' + String((e && e.message) || e) } })); } catch (_) { /* rien */ }
    /* La carte du ciel aussi (Lot 0-ciel) : sans couche, son module ne part
       jamais, et le carrousel attendrait pour rien. */
    window.__MTCI_ECHEC__ = true;
    try { document.dispatchEvent(new CustomEvent('mtci:echec', { detail: { message: 'couche : ' + String((e && e.message) || e) } })); } catch (_) { /* rien */ }
  });

  const [stats, gestes, gardeFou, ecritures, couronne, ajouter, valider, logos, rotation, haut, lieu, prix, sceau, menu, tuto, tutoBureau, perso, actions, mesLogos, attente, geste, catalogue, cadrage, arc, mte, ecrire, chercher, lienCourt, validerClient] = await Promise.all([
    import('/theme/stats.js'),
    import('/kiosk/touch.js'),
    import('/kiosk/gravure-guard.js'),
    import('/kiosk/police-picker.js'),
    import('/kiosk/couronne.js'),
    import('/kiosk/ajouter.js'),
    import('/theme/valider-web.js'),
    import('/kiosk/logo-picker.js'),
    import('/theme/rotation-coins.js'),
    import('/theme/barre-haut.js'),
    import('/theme/lieu.js'),
    import('/theme/prix-format.js'),
    import('/theme/sceau-web.js'),
    import('/theme/menu-mobile.js'),
    import('/theme/tuto-mobile.js'),
    import('/theme/tuto-bureau.js'),
    import('/theme/logo-perso.js'),
    import('/theme/couronne-actions.js'),
    import('/theme/mes-logos.js'),
    import('/theme/attente.js'),
    import('/theme/geste-nu.js'),
    import('/theme/catalogue.js'),
    import('/theme/cadrage.js'),
    import('/theme/arc-creux.js'),
    import('/theme/polices.js'),
    import('/theme/ecrire.js'),
    import('/theme/chercher-logo.js'),
    import('/theme/lien-court.js'),
    import('/theme/valider-client.js'),
  ]);

  /* LA TOMETTE PHOTO, CHARGEE A PART, et c'est voulu.

     Les modules ci-dessus tiennent dans un seul Promise.all : une 404 ou
     une faute de syntaxe dans l'un d'eux eteint toute la couche. Le module
     photo est neuf et c'est le plus lourd ; on ne lui donne pas ce
     pouvoir. Il part ici, seul, et son echec ne fait que poser
     window.__MTPX_ECHEC__ et l'evenement mtp:echec : le carrousel envoie
     alors vers la fiche photo, et tout le reste de l'editeur tourne.

     Lance AVANT les start() qui suivent : si l'un d'eux levait, le module
     photo partirait quand meme. Son start() ne s'execute de toute facon
     qu'apres ce bloc, une fois le fichier arrive. Pas d'accents graves ici,
     ce commentaire vit dans le gabarit du demarrage. */
  import('/theme/photo-expert.js')
    .then((m) => m.start())
    .catch((e) => {
      window.__MTPX_ECHEC__ = true;
      try { document.dispatchEvent(new CustomEvent('mtp:echec', { detail: { message: String((e && e.message) || e) } })); } catch (_) { /* rien */ }
      console.warn('[photo]', e);
    });

  /* LA CARTE GRAVEE, CHARGEE A PART elle aussi, pour la meme raison.

     Son echec ne fait que poser window.__MTCX_ECHEC__ et l'evenement
     mtcx:echec. La carte deja posee sur une piece reste protegee : le
     moteur la garde a sa place et refait ses reserves avant tout export
     (greffes F5 et F6), sans ce module. Lancee juste apres la photo,
     avant les start() de la couche. Pas d'accents graves ici, ce
     commentaire vit dans le gabarit du demarrage. */
  import('/theme/carte-expert.js')
    .then((m) => m.start())
    .catch((e) => {
      window.__MTCX_ECHEC__ = true;
      try { document.dispatchEvent(new CustomEvent('mtcx:echec', { detail: { message: String((e && e.message) || e) } })); } catch (_) { /* rien */ }
      console.warn('[carte]', e);
    });

  /* LA CARTE DU CIEL, CHARGEE A PART elle aussi, pour la meme raison.

     Son echec ne fait que poser window.__MTCI_ECHEC__ et l'evenement
     mtci:echec. Un ciel deja pose sur une piece reste protege : le moteur
     le garde a sa place et refait ses reserves avant tout export (greffes
     F5 et F6, garde v2), sans ce module. Lance juste apres la carte, avant
     les start() de la couche. Pas d'accents graves ici, ce commentaire vit
     dans le gabarit du demarrage. */
  import('/theme/ciel-expert.js')
    .then((m) => m.start())
    .catch((e) => {
      window.__MTCI_ECHEC__ = true;
      try { document.dispatchEvent(new CustomEvent('mtci:echec', { detail: { message: String((e && e.message) || e) } })); } catch (_) { /* rien */ }
      console.warn('[ciel]', e);
    });

  /* La barre de forme du thème existe déjà — on lui pose la classe que
     la feuille attend pour la remettre au-dessus de la pièce, là où elle
     reste atteignable une fois le rail de gauche effacé. C'est la seule
     ligne que kiosk.js exécutait et qu'il fallait reprendre ici. */
  document.getElementById('shapebar')?.classList.add('mtk-shapebar');

  /* Le garde-fou lit le catalogue des polices pour savoir lesquelles ne
     savent pas graver nos accents. Sur la borne il est à
     /data/fonts.json ; ici c'est un asset du thème, dont l'URL est posée
     par le gabarit dans `__MT_CATALOGUE_POLICES__`. */
  /* les compteurs d'abord : ils écoutent le dataLayer que les autres remplissent */
  stats.start();

  gestes.start();
  gardeFou.start();
  ecritures.start();

  /* couronne.js démarre PARTOUT, y compris sur téléphone où l'on n'affiche
     pas la couronne : c'est lui qui tient le popup d'écriture, et le popup
     est le seul vrai gain de ce portage sur petit écran. La feuille cache
     l'arc et la fiche sous 760 px ; ce qui reste actif est le popup. */
  couronne.start();

  /* Les motifs en plein écran, partout. logo-picker.js n'ajoute rien : il
     DÉTOURNE l'entrée « Motif ou votre logo » du moteur avant que sa
     feuille latérale s'ouvre. Sans lui, le bouton du thème ne donnait
     rien du tout une fois notre couche active — la feuille s'ouvrait
     derrière le voile de la couronne. */
  logos.start();

  /* Tourner en s'approchant d'un coin, comme dans un traitement de texte.
     Le module se tait de lui-même sur pointeur grossier. */
  rotation.start();

  /* La barre du haut sur téléphone : Annuler et Rétablir en grand, le prix,
     et une sortie qui passe par la confirmation du thème. Le module se tait
     de lui-même au-dessus de 760 px. */
  haut.start();

  /* Le point GPS, au centre de la pièce. Il démarre aux DEUX largeurs :
     il détourne le bouton du rail (souris) et la ligne de la feuille
     « Ajouter » (doigt), qui mènent à deux codes différents du moteur. */
  lieu.start();

  /* Ce que coûte chaque format, sous le format. Le module se tait de
     lui-même au doigt, où la barre n'a pas la place d'une seconde ligne,
     et si la couture ne porte pas le calcul du moteur. */
  prix.start();

  /* Le sceau de la borne, à la validation : la pièce seule et en grand,
     un cercle qui se trace autour d'elle, une phrase, un geste. Le
     module se tait de lui-même au doigt. */
  sceau.start();

  /* Le menu du téléphone, proposition « le tiroir » : un bouton par
     réglage, et une jauge qui se déplie à la place du rang d'écritures.
     Le module se tait de lui-même au-dessus de 760 px. */
  menu.start();

  /* Le guide des gestes prend la place de la feuille « Comment
     personnaliser » : au lieu de décrire le pincement, on le joue sur le
     prénom déjà gravé. Le module se tait de lui-même au-dessus de 760 px
     et quand le système demande moins d'animation. */
  tuto.start();

  /* Le meme guide, a la souris. Les deux observent la meme feuille
     d'accueil et un seul agit : celui du telephone sort au-dessus de
     760 px, celui-ci en dessous. */
  tutoBureau.start();

  /* Importer son logo : la borne est publique et n'en a jamais eu besoin,
     la boutique en fait sa demande la plus fréquente. Le module se tait
     de lui-même si le moteur n'a pas posé sa fonction d'import. Pas
     d'accents graves ici : ce commentaire vit DANS le littéral de
     gabarit du démarrage, et une paire d'accents le refermerait. */
  perso.start();

  /* Dupliquer et supprimer, remontes sous la couronne au lieu du pied de
     la fiche, en bas a gauche. Le module se tait au doigt : le menu du
     telephone porte deja ses deux boutons. */
  actions.start();

  /* Les logos deja importes, en tete de la grille, avec leur pastille. Le
     module enveloppe addCustomSvg pour voir passer chaque import : il doit
     donc demarrer avant que la cliente puisse en choisir un. Pas d'accents
     graves ici, ce commentaire vit dans le gabarit du demarrage. */
  mesLogos.start();

  /* L'ecran d'attente. Il doit demarrer AVANT tout le reste de ce bloc
     dans les faits — les neuf tomettes d'essai paraissent des 446 ms —
     mais c'est la classe posee sur <html> qui masque, pas le voile. */
  attente.start();

  /* Pendant un deplacement, une rotation ou un changement de taille : la
     piece entiere, et rien d'autre. Seule la barre de format reste, et
     elle cesse d'etre voilee. Pas d'accents graves ici, ce commentaire vit
     dans le gabarit du demarrage. */
  geste.start();

  /* Le catalogue de motifs, charge des le demarrage : sans lui, une
     creation rouverte depuis le panier revient avec des feuilles a la
     place de ses logos. */
  catalogue.start();
  cadrage.start();
  arc.start();
  mte.start();
  ecrire.start();

  /* La barre de recherche du selecteur de motifs : elle observe le DOM et
     se pose quand le panneau se monte. Pas d'accents graves ici, ce
     commentaire vit dans le gabarit du demarrage. */
  chercher.start();

  /* Les liens de partage deviennent courts : la recette part sur OVH
     (c.php), six caractères voyagent. L'email est raccourci côté
     serveur ; ici on couvre le partage natif (l'image reste) et le
     bouton « Copier le lien ». Sans réponse du serveur : lien long,
     comme avant — jamais un lien cassé. */
  lienCourt.start();

  /* La tomette « déjà réglée » (lien admin c.php avec &mtv=CODE) : les
     boutons du panier s'effacent, une barre « Valider cette tomette »
     prévient l'atelier par mail. Sans mtv dans l'URL : rien. */
  validerClient.start();

  /* Le bas d'écran de la borne — les deux boutons ronds et Annuler /
     Rétablir — ne démarre QUE sur grand écran. Sous 760 px, l'interface du
     thème est meilleure que la nôtre : une pile en bas qui ne se chevauche
     jamais, la roue d'écritures qui montre le mot du client dans chaque
     police, et une barre d'action qui porte le prix en permanence. Deux
     boutons de 110 px y mangeraient la moitié de la largeur pour deux
     actions, là où le thème en loge quatre et le prix.

     On mesure au chargement. Une tablette qu'on tourne ne rebascule pas :
     c'est un défaut connu, et sans conséquence ici — les deux appareils
     visés, poste et téléphone, ne changent pas de catégorie en tournant. */
  if (innerWidth > 760) {
    ajouter.start();
    valider.start();
  }

  console.info("[mt-editeur] couche d'édition active");
}
